/**
 * copyable-literal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "../alert.service";

@Component({
    selector: `copyable-literal`,
    template: `
        <pre
            class="literal"
            (click)="tryCopy()"
            title="Click to copy"
            >{{value}}</pre>
    `,
    styles: [`
        pre {
            margin-bottom: 0px;
        }
        pre:active {
            background-color: #bedefa;
        }
    `]
})
export class CopyableLiteralComponent implements OnInit
{
    @Input()
    public value : string;

    public constructor (
        public alerts: AlertService
    ) {}

    public tryCopy () : void
    {
        navigator['clipboard'].writeText(`${this.value}`).then(() => {
            this.alerts.notify(`Copied "${this.value}" to your clipboard!`);
        });
    }

    public ngOnInit(): void {
        // if we need permissions...
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/data/copyable-literal.component.ts